import produce from 'immer'

import { BENEFITS } from './types'

export const initialState = {
  loading: true,
  error: false,
  benefitsLoading: false,
  benefitsList: [],
  columns: [],
  pages: { totalPages: 0, currentPage: 0 },
  totalItems: 0,
  dataFilters: [],
  dataFiltersError: null,
  filterLoading: null,
  benefitInformation: null,
  benefitTypesLoading: null,
  benefitTypes: [],
  benefitTypesError: null
}

const reducer = (state = initialState, { type, payload }) => produce(state, draft => {
  switch (type) {
    case BENEFITS.GET:
      draft.benefitsLoading = true
      break
    case BENEFITS.SUCCESS: {
      const { items, fields, totalItems, totalPages, currentPage } = payload
      draft.loading = false
      draft.benefitsLoading = false
      draft.benefitsList = items
      draft.columns = fields
      draft.totalItems = totalItems
      draft.pages = { totalPages, currentPage }
    }
      break
    case BENEFITS.ERROR:
      draft.loading = false
      draft.error = payload
      break
    case BENEFITS.CLEAR:
      return initialState
    // FILTER
    case BENEFITS.SEND_FILTER:
      draft.loading = true
      break
    case BENEFITS.GET_FILTER_DATA:
      draft.filterLoading = true
      break
    case BENEFITS.FILTER_DATA_SUCCESS:
      draft.dataFilters = payload
      draft.filterLoading = false
      break
    case BENEFITS.FILTER_DATA_ERROR:
      draft.dataFiltersError = payload
      draft.filterLoading = false
      break
    case BENEFITS.FILTER_DATA_CLEAR:
      draft.dataFilters = []
      draft.dataFiltersError = null
      draft.filterLoading = false
      break
    // SET BENEFITS
    case BENEFITS.SET_BENEFIT:
      draft.benefitsLoading = true
      break
    case BENEFITS.BENEFIT_INFORMATION:
      draft.benefitsLoading = false
      draft.benefitInformation = payload
      break
    case BENEFITS.BENEFIT_INFORMATION_CLEAR:
      draft.benefitInformation = null
      break
    // BENEFIT TYPES
    case BENEFITS.GET_BENEFIT_TYPES:
      draft.benefitTypesLoading = true
      break
    case BENEFITS.BENEFIT_TYPES_SUCCESS:
      draft.benefitTypes = payload
      draft.benefitTypesLoading = false
      break
    case BENEFITS.BENEFIT_TYPES_ERROR:
      draft.benefitTypesError = payload
      draft.benefitTypesLoading = false
      break
    default:
      return initialState
  }
})

export default reducer
